var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E4F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7924_21036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2229 14H21.1063C19.1326 14 17.5 15.6242 17.5 17.5979V42.4022C17.5 44.3758 19.1326 46 21.1063 46H38.9092C40.8828 46 42.515 44.3758 42.515 42.4022V22.6984L34.2229 14Z",
    fill: "#438BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2637 14.0244L42.5236 22.7064H37.025C35.4982 22.7064 34.2637 21.4721 34.2637 19.9453V14.0244Z",
    fill: "#3F66D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6922 39.583H23.3236C22.8771 39.583 22.5117 39.9484 22.5117 40.3951C22.5117 40.842 22.8771 41.2074 23.3236 41.2074H36.7004C37.1471 41.2074 37.5125 40.842 37.5125 40.3951C37.5125 39.9484 37.1471 39.583 36.6922 39.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8499 30.8443L29.196 27.2465V36.1152C29.196 36.5621 29.5614 36.9275 30.0081 36.9275C30.4548 36.9275 30.8204 36.5621 30.8204 36.1152V27.2461L34.1665 30.8443C34.3288 31.0146 34.5399 31.1041 34.7593 31.1041C34.9544 31.1041 35.1571 31.0311 35.3118 30.8848C35.6364 30.5762 35.6608 30.0645 35.3522 29.7396L30.6011 24.6309C30.4468 24.4686 30.2356 24.3711 30.0083 24.3711C29.7807 24.3711 29.5696 24.4686 29.4153 24.6309L24.6641 29.7396C24.3556 30.0645 24.38 30.5844 24.7046 30.8848C25.0296 31.1934 25.5411 31.1689 25.8499 30.8443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7924_21036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.50b0e98f160e866db9f6bf486dbeeb1a.svg";
export { ForwardRef as ReactComponent };